/* eslint-disable @typescript-eslint/restrict-template-expressions */
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { Button, Badge } from '@pwc/pwc-deals-ui';
import { FC, useMemo } from 'react';
import RibbonPanelButton, { RibbonButtonTypeProps } from './RibbonPanelButton';
import { useCommentCounts } from '../../hooks/useCommentCounts';

type Props = {
  handlePanelButtonClick: (type: RibbonButtonTypeProps) => void;
  ribbonType: string | null;
  visibleButtons: string[];
  isEntitySharedWithClient: boolean;
  viewingStatus: 'unresolved' | 'resolved';
  isPanelOpened: boolean;
};

const wrapperOptions: RibbonButtonTypeProps[] = [
  {
    type: 'comment',
  },
  {
    type: 'preview',
  },
  {
    type: 'versioning',
  },
];

const RibbonWrapper: FC<Props> = ({
  handlePanelButtonClick,
  ribbonType,
  visibleButtons,
  isEntitySharedWithClient: isShared,
  viewingStatus,
  isPanelOpened,
}) => {
  const { visibleCommentCounts } = useCommentCounts({
    isShared,
    viewingStatus,
    isPanelOpened,
  });

  const visbleWrapperOptions = useMemo(() => {
    if (visibleButtons.length) {
      return wrapperOptions
        .filter(
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          ({ type }) => visibleButtons.includes(type!)
        )
        .map((item): RibbonButtonTypeProps => {
          if (item.type === 'comment' && visibleCommentCounts > 0) {
            const text =
              visibleCommentCounts > 9 ? '9+' : String(visibleCommentCounts);

            return {
              ...item,
              badge: {
                text,
              },
            };
          }

          return item;
        });
    }

    return [];
  }, [visibleButtons, visibleCommentCounts]);

  return (
    <div className="ribbon-wrapper-items">
      <List sx={{ paddingTop: 0, paddingBottom: 0 }}>
        {visbleWrapperOptions &&
          visbleWrapperOptions.map(({ type, badge }) => {
            return (
              <div
                className={`${type} panel-button-icon-container${
                  ribbonType === type ? ' selected' : ''
                }`}
                key={type}
              >
                <ListItem disablePadding>
                  {!!badge && (
                    <Badge cssClass={badge.className} show text={badge.text} />
                  )}
                  <Button
                    className="panel-button"
                    aria-label={`${type} icon`}
                    data-testid="panel-button"
                    onClick={() => handlePanelButtonClick({ type })}
                    icon={undefined}
                    iconClasses={undefined}
                  >
                    <RibbonPanelButton
                      ribbon={{ type }}
                      ribbonType={ribbonType}
                    />
                  </Button>
                </ListItem>
              </div>
            );
          })}
      </List>
    </div>
  );
};

export default RibbonWrapper;
